import React, { useRef, useEffect } from "react";
import { appConfig } from "../config";

const NewZealandComponent = ({ getIframe }) => {
  const iframe = useRef(null);

  useEffect(() => {
    getIframe(iframe);
  }, [getIframe]);

  return (
    <>
      <iframe
        id="vista"
        ref={iframe}
        style={{ height: "100%", width: "100%", overflow: "hidden", border: "none" }}
        allowFullScreen={false}
        title="NewZealand"
        scrolling="no"
        src={appConfig.vistaUrl}
      ></iframe>
    </>
  );
};

const NewZealand = React.memo(NewZealandComponent);

export { NewZealand };
